/** Velocity bucket colors */
export const VELOCITY_BUCKET_COLORS: Record<string, string> = {
  rapidly_improving: '#4CAF50',
  improving: '#4CAF50',
  stable: '#8aa4bd',
  declining: '#f59e0b',
  rapidly_declining: '#ef4444',
};

/** Velocity bucket translation keys */
export const VELOCITY_BUCKET_LABEL_KEYS: Record<string, string> = {
  rapidly_improving: 'velocity.buckets.rapidly_improving',
  improving: 'velocity.buckets.improving',
  stable: 'velocity.buckets.stable',
  declining: 'velocity.buckets.declining',
  rapidly_declining: 'velocity.buckets.rapidly_declining',
};

